import { Component, inject } from '@angular/core';
import FormService from '../forms.service';
import { Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import CurrentFormService from '../current_form.service';
import AuthService from '../../services/auth.service';

@Component({
  selector: 'app-form-select',
  imports: [CommonModule, RouterLink],
  templateUrl: './form-select.html',
  styleUrl: './form-select.css',
})
export class FormSelect {
  private formService = inject(FormService);
  private currentFormService = inject(CurrentFormService);
  protected displayMenu = true;

  private authService = inject(AuthService);
  private router = inject(Router);

  forms$: Observable<{ name: string; id: string; icon?: string; in_bottom?: boolean }[]> =
    this.formService.getForms();

  toggleMenu() {
    this.displayMenu = !this.displayMenu;
  }

  logout() {
    this.authService.logout();
    this.router.navigate(['auth', 'login']);
  }

  protected resetForm() {
    this.currentFormService.reset();
  }
}
